import { render, staticRenderFns } from "./index.vue?vue&type=template&id=452b8244&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b8244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452b8244')) {
      api.createRecord('452b8244', component.options)
    } else {
      api.reload('452b8244', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=452b8244&scoped=true", function () {
      api.rerender('452b8244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/order/source-strategy/parcel/index.vue"
export default component.exports